import { useState } from 'react'
import { motion } from 'framer-motion'
import type { StepFeel as StepFeelType } from '@/types/storytelling'

interface StepFeelProps {
  step: StepFeelType
  onComplete: (choiceMade: string) => void
}

export function StepFeel({ step, onComplete }: StepFeelProps) {
  const [selected, setSelected] = useState<string | null>(null)

  const handleSelect = (emoji: string) => {
    setSelected(emoji)
    onComplete(emoji)
  }

  return (
    <div className="px-5 py-6">
      <p className="text-xs font-semibold uppercase tracking-wider mb-3" style={{ color: 'var(--color-story-primary-light)' }}>Feel it first</p>
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.8 }} className="rounded-2xl p-5 mb-4 bg-white" style={{ border: '1px solid var(--color-story-border)' }}>
        <p className="text-base leading-relaxed italic" style={{ color: 'var(--color-story-text)' }}>"{step.storyMoment}"</p>
      </motion.div>
      <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 1.2, duration: 0.5 }} className="rounded-2xl p-5" style={{ background: 'linear-gradient(135deg, var(--color-story-bg), var(--color-story-bg-light))', border: '1px solid var(--color-story-border)' }}>
        <p className="font-semibold text-sm mb-3" style={{ color: 'var(--color-story-text)' }}>{step.question}</p>
        <div className="flex flex-col gap-2">
          {step.reflectionChoices.map((choice) => (
            <button key={choice.emoji} onClick={() => handleSelect(choice.emoji)} className="flex items-center gap-3 rounded-xl px-4 py-3 text-left text-sm transition-all" style={{ background: selected === choice.emoji ? 'var(--color-story-primary)' : 'white', color: selected === choice.emoji ? 'white' : 'var(--color-story-text)', border: `2px solid ${selected === choice.emoji ? 'var(--color-story-primary)' : 'var(--color-story-border)'}` }}>
              <span className="text-lg">{choice.emoji}</span>
              {choice.text}
            </button>
          ))}
        </div>
      </motion.div>
    </div>
  )
}
